export const normalizeCalendarDate = (value: string | Date) => {
    if (typeof value === 'string') {
        const isoDate = /^(\d{4}-\d{2}-\d{2})/.exec(value);
        if (isoDate)
            return isoDate[1];
    }

    const date = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(date.getTime()))
        return undefined;

    return [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0'),
    ].join('-');
};
